import { declareString } from "@1js/localization";

export const ShareToTeamTitle = declareString(
  "promptLibrary.shareToTeamTitle",
  {
    text: "Share this prompt to a team",
    comment: "Dialog title to share a prompt to a team.",
  }
);

export const ShareToTeamTeamsLabel = declareString(
  "promptLibrary.shareToTeamTeamsLabel",
  {
    text: "Share to",
    comment: "Dropdown label to select a team.",
  }
);

export const ShareToTeamTeamsDropdownPlaceholder = declareString(
  "promptLibrary.shareToTeamTeamsDropdownPlaceholder",
  {
    text: "Select or enter a team name",
    comment: "Dropdown label to select a team.",
  }
);

export const ShareToTeamCancelButtonLabel = declareString(
  "promptLibrary.shareToTeamCancelButtonLabel",
  {
    text: "Cancel",
    comment: "Button label to cancel sharing a prompt to a team.",
  }
);

export const ShareToTeamShareButtonLabel = declareString(
  "promptLibrary.shareToTeamShareButtonLabel",
  {
    text: "Share",
    comment: "Button label to share a prompt to a team.",
  }
);

export const CloseTooltip = declareString("promptLibrary.closeTooltip", {
  text: "Close",
  comment: "Tooltip text for close button.",
});
